module.exports = __webpack_public_path__ + "static/django-1d528e2cb5fbc29ad16c74e5d883c371.png";